import { render, staticRenderFns } from "./CreateEditClient.vue?vue&type=template&id=4083988b&scoped=true&"
import script from "./CreateEditClient.vue?vue&type=script&lang=js&"
export * from "./CreateEditClient.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditClient.vue?vue&type=style&index=0&id=4083988b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083988b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VForm,VRow})
